import React, { useContext } from 'react'
import { IntegrationsCol } from './integrations-col'
import { DomainIntegrationsManagerContext } from '../context'
import { GetDomainIntegrationResponse, GetWordpressDomainIntegrationResponse } from '@pushly/models/lib/structs/domains'
import WordpressIntegration from '../providers/wordpress-integration'
import { DomainIntegrationProviders } from '@pushly/models/lib/enums/domain-integration-providers'

const isWordpressProvider = (di: GetDomainIntegrationResponse) => di.provider === DomainIntegrationProviders.WORDPRESS

const toWordpressGetResponse = (di: GetDomainIntegrationResponse) =>
    GetWordpressDomainIntegrationResponse.fromGetDomainIntegrationResponse(di)

export const CmsIntegrations: React.FC = () => {
    const { loading, integrations } = useContext(DomainIntegrationsManagerContext)

    const wpIntegrations: GetWordpressDomainIntegrationResponse[] = []
    if (integrations) {
        integrations.filter(isWordpressProvider).forEach((di) => wpIntegrations.push(toWordpressGetResponse(di)))
    }

    return (
        <IntegrationsCol className="cms-integrations" label="Content Management Systems" loading={loading}>
            {wpIntegrations.length === 0 && <WordpressIntegration loading={loading} mode="add" />}
            {wpIntegrations.map((di) => (
                <WordpressIntegration key={di.id} loading={loading} mode="edit" integration={di} />
            ))}
        </IntegrationsCol>
    )
}
